module.exports = __webpack_public_path__ + "static/img/err-2.f495bbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/err-2.png
// module id = kESN
// module chunks = 1